export default __webpack_public_path__ + "static/media/LP-D1-CW.fe9b6f0b.jpg";